import React from 'react';
import { FileText, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const TermsOfServicePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-6">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700 mb-4 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </button>
          <div className="flex items-center gap-3">
            <div className="p-2 bg-indigo-50 rounded-lg">
              <FileText className="w-6 h-6 text-indigo-600" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Terms of Service</h1>
              <p className="text-sm text-gray-500 mt-0.5">AI SENSE, Inc.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 sm:p-8 space-y-8">
          <p className="text-sm text-gray-500">Effective Date: February 14, 2026</p>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">1. Acceptance of Terms</h2>
            <p className="text-gray-600 leading-relaxed">
              By accessing or using this website, you agree to be bound by these Terms of Service.
              If you do not agree to these terms, please do not use our website or services.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">2. About AI SENSE</h2>
            <p className="text-gray-600 leading-relaxed">
              AI SENSE is a climate and agricultural technology company providing:
            </p>
            <ul className="mt-2 space-y-1.5 text-gray-600">
              <li className="flex items-start gap-2">
                <span className="text-gray-400 mt-1.5 text-xs">&#9679;</span>
                AI-powered monitoring systems
              </li>
              <li className="flex items-start gap-2">
                <span className="text-gray-400 mt-1.5 text-xs">&#9679;</span>
                Agricultural intelligence software
              </li>
              <li className="flex items-start gap-2">
                <span className="text-gray-400 mt-1.5 text-xs">&#9679;</span>
                Hardware-enabled farm protection solutions
              </li>
              <li className="flex items-start gap-2">
                <span className="text-gray-400 mt-1.5 text-xs">&#9679;</span>
                Climate data analytics services
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">3. Use of Website</h2>
            <p className="text-gray-600 leading-relaxed">
              You agree not to use the website for any unlawful purposes or attempt to access
              restricted areas of the website, its servers, or any connected systems. Any
              unauthorized use may result in termination of your access.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">4. Intellectual Property</h2>
            <p className="text-gray-600 leading-relaxed">
              All content, logos, product names, software, and materials displayed on this website
              are the intellectual property of AI SENSE, Inc. You may not reproduce, distribute,
              or create derivative works from any content without prior written consent.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">5. No Warranties</h2>
            <p className="text-gray-600 leading-relaxed">
              The website and all services are provided "as is" without warranties of any kind,
              either express or implied, including but not limited to implied warranties of
              merchantability, fitness for a particular purpose, or non-infringement.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">6. Limitation of Liability</h2>
            <p className="text-gray-600 leading-relaxed">
              AI SENSE, Inc. shall not be liable for any indirect, incidental, special, or
              consequential damages, including but not limited to lost profits, data loss,
              or business interruption, arising out of or in connection with the use of our
              website or services.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">7. Governing Law</h2>
            <p className="text-gray-600 leading-relaxed">
              These Terms of Service are governed by and construed in accordance with the laws
              of the State of Delaware, United States, without regard to its conflict of law
              provisions.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">8. Contact Us</h2>
            <p className="text-gray-600 leading-relaxed">
              If you have any questions about these Terms of Service, please contact us at:
            </p>
            <div className="mt-3 p-4 bg-gray-50 rounded-lg">
              <p className="font-medium text-gray-900">AI SENSE, Inc.</p>
              <p className="text-gray-600 mt-1">Email: contact@aisenseusa.com</p>
              <p className="text-gray-600">Website: www.aisenseusa.com</p>
            </div>
          </section>
        </div>

        <p className="text-center text-xs text-gray-400 mt-6">
          &copy; {new Date().getFullYear()} AI SENSE, Inc. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
